import React, {useState} from 'react';
import {postRequest} from "../routes/Routes";
import {createUser} from "../auth/Auth";

import '../assests/css/Signin.css';

function Signin() {
    const [inputs, setInputs] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
    }

    const loginFunction = (event) => {
        setLoading(true);
        event.preventDefault();
        let values = {
            email: event.target.email.value,
            password: event.target.password.value,
            endpoint: '/api/login'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    setError(values => ({...values, error: true, errorMessage: response.data.message}));
                } else {
                    createUser(response.data.user).then(() => {
                        setError(values => ({...values, error: false, errorMessage: null}));
                        window.location.href = '/';
                    });
                }
            } else {
                setError(values => ({...values, error: true, errorMessage: "An error occurred!"}));
            }
            setLoading(false);
        });
    }

    return (
        <div className="login-container">
            <div className="login-left">
                <img src="/logo.png" alt="Logo" className="login-logo" />
            </div>
            
            <div className="login-right">
                <div className="login-form-container">
                    <form onSubmit={loginFunction}>
                        <div>
                            <label>Email address</label>
                            <input 
                                type="email" 
                                name="email" 
                                value={inputs.email || ""}
                                onChange={handleChange} 
                                required
                            />
                        </div>
                        <div>
                            <label>Password</label>
                            <input 
                                type="password" 
                                name="password"
                                value={inputs.password || ""}
                                onChange={handleChange} 
                                required
                            />
                        </div>
                        {error.error &&
                        <div className="alert login-alert alert-danger" role="alert">
                            {error.errorMessage}
                        </div>}
                        <div>
                            <button type="submit" className="login-btn" disabled={loading}>
                                {loading ?
                                    <span className="spinner-grow spinner-grow-sm ml-1" role="status" aria-hidden="true" style={{marginRight: "8px"}}/>
                                    : null
                                }
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Signin;
